import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';

// Angular Fire
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';

// Componentes globales standalone
import { FooterComponent } from './modules/global/footer/footer.component';
import { TimeoutErrorComponent } from './modules/maintenance/components/timeout-error/timeout-error.component';
import { LoadingComponent } from './modules/home/components/loading/loading.component';
import { ServerUnavailableComponent } from './modules/maintenance/components/server-unavailable/server-unavailable.component';

// Pipes y Directivas
import { GLOBAL_PIPES } from './modules/global/pipes/index';
import { GLOBAL_DIRECTIVES } from './modules/global/directives/index';

// Servicios
import { InfinityService } from './modules/dashboard/services/infinity/infinity.service';
import { DataService } from './modules/global/services/data.service';
import { SalesforceMessagingService } from './modules/global/services/salesforce-messaging/salesforce-messaging.service';

// Constantes
import { objButtons } from './modules/home/constants/header-buttons';
import { SurveysBannerBrand } from './modules/global/constants/app-config';

// UUID
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    // Angular core modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule, // Para <router-outlet> y routerLink

    // Material modules
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatMenuModule,
    MatListModule,

    // Componentes globales standalone
    FooterComponent,
    TimeoutErrorComponent,
    LoadingComponent,
    ServerUnavailableComponent,

    // Pipes y Directivas
    ...GLOBAL_PIPES,
    ...GLOBAL_DIRECTIVES,
  ]
})
export class AppComponent implements OnInit {
  @ViewChild('sidenav') sidenav!: MatSidenav;

  title = 'my-app';
  now = new Date();
  objButtons = objButtons;
  errorMenu = false;
  callcenterMenu = false;
  mobileMenu = false;
  qrMenu = false;
  infoRouteShow = false;
  infoDialogShow: boolean;
  infoBannerClass: string;
  showBannerdForBrand = false;
  scrollDown = false;
  chatBtnLoaded: boolean = false;

  constructor(
    private dataService: DataService,
    private snackBar: MatSnackBar,
    private router: Router,
    private dateAdapter: DateAdapter<Date>,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private firebase: AngularFireAnalytics,
    private infinityService: InfinityService,
    private salesforceMessaging: SalesforceMessagingService,
  ) {
    iconRegistry.addSvgIcon('menu', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/menu-24px.svg'));
    iconRegistry.addSvgIcon('close', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/clear-24px.svg'));
    this.dataService.setIsLoading(true);
    this.dataService.setUserAuthStatus(false);
    this.dataService.setAuthStatus(false);
    this.dataService.setIsLoginOffline(false);
    this.dateAdapter.setLocale('es');

    this.dataService.getGeneralNotificationMessage().subscribe(msg => {
      this.snackBar.open(msg, 'OK', {
        duration: 17000,
        panelClass: this.footerInViewport() ? 'margin-bt' : ''
      });
    });

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e) => {
        if (e instanceof NavigationEnd) {
          this.infinityService.sendCustomInfinityTag(e.urlAfterRedirects);
          this.bannerForBrand(e);
          this.checkUrlMenu(e);
          this.showInfoBanner(e);
          this.sendFirebaseEvent(e.urlAfterRedirects);
        }
      });

    this.salesforceMessaging.getButtonLoadedSubject().subscribe(btnLoaded => {
      this.chatBtnLoaded = btnLoaded;
    })

    this.infoDialogShow = this.dataService.getInfoShow();
    this.infoBannerClass = 'info-banner-hide';
    this.checkDeviceId();
  }

  ngOnInit(): void {
    this.dataService.setIsLoading(false);
    this.salesforceMessaging.initMessaging();
  }

  bannerForBrand(e: NavigationEnd) {
    this.showBannerdForBrand = false;
    SurveysBannerBrand.forEach(element => {
      if (e.url.includes(element)) {
        this.showBannerdForBrand = true;
      }
    });
  }

  showInfoBanner(e: NavigationEnd) {
    if (!e.urlAfterRedirects.includes('mobile') && !e.urlAfterRedirects.includes('store-qr') && this.infoRouteShow) {
      this.dataService.setIsLoading(false);
      this.infoRouteShow = true;
      this.infoBannerClass = this.infoBannerClass === 'info-banner-hide' ? 'info-banner' : 'info-banner-hide';
      this.dataService.setInfoShow(true);
    }
  }

  closeInfoBanner() {
    this.infoBannerClass = this.infoBannerClass === 'info-banner-hide' ? 'info-banner' : 'info-banner-hide';
    setTimeout(() => {
      this.infoDialogShow = true;
    }, 1000);
  }

  checkUrlMenu(e: NavigationEnd) {
    this.errorMenu = false;
    this.callcenterMenu = false;
    this.mobileMenu = false;
    this.qrMenu = false;
    if (e.urlAfterRedirects.endsWith('500')) {
      this.errorMenu = true;
    }
    if (e.urlAfterRedirects.includes('callcenter')) {
      this.callcenterMenu = true;
    }
    if (e.urlAfterRedirects.includes('mobile')) {
      this.mobileMenu = true;
    }
    if (e.urlAfterRedirects.includes('store-qr')) {
      this.qrMenu = true;
    }
  }

  sendFirebaseEvent(url?: string) {
    let eventParamName = 'web_view';
    const charLimit = 40;
    if (url) {
      eventParamName = eventParamName + url.replace('dashboard/', '').split('/').join('_');
    }
    this.firebase.logEvent(eventParamName.toLowerCase().slice(0, charLimit), {});
  }

  goToTerms() {
    this.closeInfoBanner();
    this.router.navigate(['privacy-policy']);
  }

  footerInViewport() {
    const el = document.getElementById('footer');
    if (el === null) return false;
    const rect = el.getBoundingClientRect();
    const vWidth = window.innerWidth || document.documentElement.clientWidth;
    const vHeight = window.innerHeight || document.documentElement.clientHeight;
    const efp = (x: number, y: number) => document.elementFromPoint(x, y);
    if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) {
      return false;
    }
    return (
      el.contains(efp(rect.left, rect.top))
      || el.contains(efp(rect.right, rect.top))
      || el.contains(efp(rect.right, rect.bottom))
      || el.contains(efp(rect.left, rect.bottom))
    );
  }

  checkDeviceId() {
    const device = localStorage.getItem('device_id');
    if (!device) {
      const id = uuidv4();
      localStorage.setItem('device_id', id);
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  @HostListener('window:scroll')
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.scrollDown = scrollPosition >= 30;
  }
}
